export const UnknownUser = {
  full_name: "Unknown User",
  initials: "UU",
  avatar_url: null,
};
